/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Claude_Web_AddInputs */

const en_mcp_claude_web_add = /** @type {(inputs: Mcp_Claude_Web_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose + Add, then Add custom connector. Name it Listening, paste the MCP URL and choose Add.`)
};

const es_mcp_claude_web_add = /** @type {(inputs: Mcp_Claude_Web_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige + Add y luego Add custom connector. Llámalo Listening, pega la URL de MCP y elige Add.`)
};

/**
* | output |
* | --- |
* | "Choose + Add, then Add custom connector. Name it Listening, paste the MCP URL and choose Add." |
*
* @param {Mcp_Claude_Web_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_claude_web_add = /** @type {((inputs?: Mcp_Claude_Web_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Claude_Web_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_claude_web_add(inputs)
	return en_mcp_claude_web_add(inputs)
});